import { useQuery } from 'react-query'
import { AxiosError } from 'axios'
import { get, orderBy } from 'lodash'

import { fetchAPI } from '@/lib/api'

import { CALENDAR_SETTINGS } from '../constants'
import { CalendarSettingsT } from '../types'

type CalendarSettingParams = { city_id: number; collection_site_id: number }

const getCalendarSettings = async (
  params: CalendarSettingParams,
): Promise<CalendarSettingsT[]> => {
  const response = await fetchAPI({
    path: `/cities/${params.city_id}/collection_sites/${params.collection_site_id}/calendars/settings`,
  })

  const data = get(response, 'data.calendars', [])

  const formattedData = data.map(([garbage_name, ordering]) => ({
    ordering,
    garbage_name,
  }))

  return [
    ...orderBy(
      formattedData.filter((item) => item.ordering !== 0),
      'ordering',
    ),
    ...orderBy(
      formattedData.filter((item) => item.ordering === 0),
      'garbage_name',
    ),
  ]
}

export const useCalendarSettings = (params: CalendarSettingParams) => {
  return useQuery<CalendarSettingsT[], AxiosError>({
    queryKey: [CALENDAR_SETTINGS],
    queryFn: () => getCalendarSettings(params),
  })
}
